module.exports = __webpack_public_path__ + "media/vo-04-05.a65c2ad7.mp3";